import { selectParticipants, selectSquad, selectWaitingList } from 'modules/teams/domain/utils/team-rosters';
import { useGetTeamByIdQuery } from 'modules/teams/store/teams-api';
import { useMemo } from 'react';

/**
 * Данные карточки команды: сама команда и три списка, по одному на вкладку.
 *
 * Всё приходит одним запросом, поэтому переключение вкладок не порождает
 * новых обращений к сети, а загрузка одной вкладки не блокирует остальные.
 */
export function useTeamDetails(teamId: number) {
  // На страницу игрока можно зайти без команды в state — тогда teamId будет NaN.
  const skip = !teamId || Number.isNaN(teamId);

  const { data: team, isLoading, isFetching, isError, isSuccess, refetch } = useGetTeamByIdQuery(teamId, { skip });

  const squad = useMemo(() => selectSquad(team?.players), [team?.players]);
  const participants = useMemo(() => selectParticipants(team?.players), [team?.players]);
  const waitingList = useMemo(() => selectWaitingList(team?.entryRequests), [team?.entryRequests]);

  return {
    team: team ?? undefined,
    squad,
    participants,
    waitingList,
    isLoading,
    isFetching,
    isError,
    /** Запрос удался, но команды с таким id нет. */
    notFound: isSuccess && team === null,
    refetch,
  };
}
